import React from "react";
import { Image, Text, View } from "react-native";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppColors } from "../../utility/AppColors";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppImages } from "../../utility/AppImages";
import SubscriotionPlanComponent from "./SubscriotionPlanComponent";

const SubscriptionTabComponent = () => {
  const styles = useStyles();
  const deviceSize = useDeviceSize();

  return (
    <View>
      <View style={{ flexDirection: "row", gap: 20 }}>
        <SubscriotionPlanComponent styles={styles} />
        {deviceSize === DEVICE_SIZES.SM ||
        deviceSize === DEVICE_SIZES.XS ? null : (
          <View>
            <Image
              source={AppImages.upgradeToPro}
              style={{
                width: 622,
                height: 598,
                borderRadius: 10,
              }}
              resizeMode="contain"
            />
          </View>
        )}
      </View>
      <View
        style={{
          backgroundColor: AppColors.purple_453B50,
          height: 129,
          width:
            deviceSize === DEVICE_SIZES.SM ||
            deviceSize === DEVICE_SIZES.XS ||
            deviceSize === DEVICE_SIZES.MD ||
            deviceSize === DEVICE_SIZES.LG
              ? "auto"
              : 982,
          borderRadius: 10,
          padding: 10,
          marginTop: 20,
        }}
      >
        <Text
          style={[AppFontStyle.BOLD_ANYBODY_20, { color: AppColors.white }]}
        >
          Billing History
        </Text>
        <Text
          style={[
            AppFontStyle.REGULAR_ANYBODY_14,
            { color: AppColors.white, marginTop: 15 },
          ]}
        >
          Your billing history will show up once you have subscribed as
          ESQUADIFI Pro user.
        </Text>
      </View>
    </View>
  );
};

export default SubscriptionTabComponent;

const useStyles = CreateResponsiveStyle(
  {
    ul: {
      paddingLeft: 10,
    },
    li: {
      flexDirection: "row",
      alignItems: "flex-start",
    },
    bulletPoint: {
      fontSize: 14,
      marginRight: 10,
    },
    liText: {
      fontSize: 14,
      lineHeight: 18,
      fontFamily: "Helvetica",
    },
    upgradeBtn: {
      flexDirection: "row",
      // backgroundColor: AppColors.blue_5145E2,
      alignItems: "center",
      justifyContent: "center",
      borderRadius: 91,
      paddingHorizontal: 18,
      marginVertical: 10,
      position: "relative",
      width: 303,
      height: 49,
    },
  },
  {
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.SM]: {},
    [DEVICE_SIZES.XS]: {},
  }
);
